// Вкладки карточки ЗАЯВКИ (правка), перенесённые из Office (dict/client-request-detail-list).
// Права-вкладки: office_api/office_port/areas/requests/ep_cr_card.py (TAB_GRANTS). Формат:
//   export const tabsCodes = { OA__RemontFormOfficeXxxTab: "officeXxx" };          // право-вкладка → компонент
//   export const components = { officeXxx: defineAsyncComponent(() => import("./xxx/index.vue")) };
//   export const groups = { contract: ["officeXxx"] };   // ключи групп — TAB_GROUPS в ../tabGroups.js
//   export const aliases = { officeXxx: "слова для поиска" };
// Блоки, дописанные в существующие вкладки и шапку: ./crBlocks (HeaderExtras — шапка, ProjectRequests — «Проекты ремонта»).
import { defineAsyncComponent } from "vue";

export const tabsCodes = {
  OA__RemontFormOfficePropsEditTab: "crProps",
  OA__RemontFormOfficeOperatorCommentTab: "crComment",
};

export const components = {
  crProps: defineAsyncComponent(() => import("./crProps/index.vue")),
  crComment: defineAsyncComponent(() => import("./crComment/index.vue")),
};

export const groups = {
  contract: ["crProps", "crComment"],
};

export const aliases = {
  crProps: "реквизиты правка изменить собственник иин договор номер договора скидки акции промокод компания подписант бик",
  crComment: "комментарий оператора",
};
